import { useCallback, useEffect } from 'react';
import useIsMobileView from './useIsMobileView';

const referenceSize = 16;

export const useRootFontSize = (ref?: React.RefObject<HTMLDivElement>, baseSize = 16) => {
  const isMobile = useIsMobileView({ checkForUserAgent: true });

  const adjustFontSize = useCallback(() => {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let calculatedSize = (width / 100) * (baseSize / referenceSize);

    if (ref?.current) {
      // this is used in TablePlay and determines the size of the font based on the width of the table
      const element = ref?.current;

      width = element.offsetWidth;
      height = element.offsetHeight;
      if (!isMobile) {
        calculatedSize = (width / 65) * (baseSize / referenceSize);
      } else {
        calculatedSize = (height / 80) * (baseSize / referenceSize);
      }
    }

    document.documentElement.style.fontSize = `${calculatedSize}px`;
  }, [ref, baseSize, isMobile]);

  useEffect(() => {
    adjustFontSize(); // Initial adjustment
    const element = window;
    element.addEventListener('resize', adjustFontSize);
    return () => element.removeEventListener('resize', adjustFontSize);
  }, [adjustFontSize]);
};
